import WrapperEmptyState from 'components/layout/WrapperEmptyState';
import Load from 'components/load/Load';
import PageWrapper from 'components/utils/PageWrapper';
import Loads from 'pages/Loads';
import loadPlaceholder from '../images/load-unselected.png';

export const loadsRoutes = {
    path: '/loads',
    element: (
        <PageWrapper titleId="load_title">
            <Loads />
        </PageWrapper>
    ),
    children: [
        {
            index: true,
            element: <WrapperEmptyState imgSrc={loadPlaceholder} page="Load" noun="properties" />,
        },
        {
            path: ':loadId',
            element: <Load />,
        },
    ],
};
